export enum FunctionType {
  function = "function",
  menu = "menu",
  webapi = "webapi"
}
